jQuery( document ).ready(function() {



function addLeadingZeros(num, totalLength) {
  return String(num).padStart(totalLength, '0');
}


  let windowWidth = jQuery( window ).width();

	jQuery('.link-large-image').magnificPopup({
	  type: 'image'
	  // other options
	});

	// sticky header
	 // Hide Header on on scroll down
	var lastScrollTop = 0;
	var navbarHeight = jQuery('.site-header').outerHeight();
  if(!jQuery('body').hasClass('admin-bar')){
    jQuery('body').css('padding-top', navbarHeight);
  } else {
    if(windowWidth < 782) {
      jQuery('body').css('padding-top', navbarHeight - 46);
    } else {
      jQuery('body').css('padding-top', navbarHeight - 32);
    }
  }

  jQuery( window ).resize(function() {
    var navbarHeight = jQuery('.site-header').outerHeight();
    if(!jQuery('body').hasClass('admin-bar')){
      jQuery('body').css('padding-top', navbarHeight);
    } else {
      if(windowWidth < 782) {
        jQuery('body').css('padding-top', navbarHeight - 46);
      } else {
        jQuery('body').css('padding-top', navbarHeight - 32);
      }
    }
  });

	jQuery(window).scroll(function(event){
	   	if(lastScrollTop > jQuery(window).scrollTop()){
	    //going up
        // jQuery('.site-header').css('top', jQuery(window).scrollTop());
	    
	    if(jQuery(window).scrollTop() <= navbarHeight){
	    	jQuery('.site-header').removeClass('scroll--down');
        jQuery('.site-header').removeClass('scroll--up');
	    } else {
	      	jQuery('.site-header').removeClass('scroll--down');
	      	jQuery('.site-header').addClass('scroll--up');
          jQuery('.site-header').css('margin-top', 0);
          if(windowWidth > 1280) {
            jQuery('#hamburger-menu').css('transform', '');
          }
	    } 

	    } else {
	    //going down
	    	if(jQuery(window).scrollTop() > navbarHeight){
	      	if(!jQuery('.site-header').hasClass('scroll--down')){
	      		jQuery('.site-header').addClass('scroll--down');
	      		jQuery('.site-header').removeClass('scroll--up');
		      	jQuery('.site-header').css('margin-top', -navbarHeight);
            if(jQuery('#hamburger-menu').hasClass('active')){
              if(windowWidth > 1280) {
                jQuery('#hamburger-menu').css('transform', 'translateY(-100%)');
              }
            }
	      	}
	      	// jQuery('.site-header').css('top', jQuery(window).scrollTop());  
		      
	      }
	    }
	    lastScrollTop = jQuery(document).scrollTop();
	});

  // height of hero container
  // var heroContainer = jQuery('.hero .hero-content').outerHeight( true );
  // jQuery('.hero').css({ 'height': heroContainer });
  // jQuery( window ).resize(function() {
  //   var heroContainer = jQuery('.hero .hero-content').outerHeight( true );
  //   jQuery('.hero').css({ 'height': heroContainer });
  // });


  // toggle
  // jQuery('.accordion ol li h3').on('click', function() {
  //   jQuery('.accordion ol li h3').parent('li').removeClass('active');
  //   jQuery('.accordion ol li h3').next('.description').removeClass('show');
  //   jQuery('.accordion ol li h3').next('.description').slideUp('slow');

  //   if( jQuery(this).next('.description').hasClass('show') ) {
  //     // jQuery(this).parent('li').removeClass('active');
  //     jQuery(this).next('.description').removeClass('show');

  //   } else {
  //     jQuery(this).parent('li').addClass('active');
  //     jQuery(this).next('.description').addClass('show');
  //     jQuery(this).next('.description').slideDown('slow');
  //   }
  // });
	
  // hero slider
  jQuery('.hero-slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    dots: false,
    speed: 600,
    fade: true,
    cssEase: 'linear'
  });

  jQuery('.hero--slider .slider-navigation .slick-next').on('click', function(){
    jQuery('.hero-slider .slick-next').trigger('click');
  });

  jQuery('.hero--slider .slider-navigation .slick-prev').on('click', function(){
    jQuery('.hero-slider .slick-prev').trigger('click');
  });

  // blog slider
  jQuery('.blog-slider').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  jQuery('.blog-wrapper .heading-wrapper .slider-navigation .right-arrow svg').on('click', function(){
    jQuery('.blog-slider .slick-next').trigger('click');
  });
  jQuery('.blog-wrapper .heading-wrapper .slider-navigation .left-arrow svg').on('click', function(){
    jQuery('.blog-slider .slick-prev').trigger('click');
  });


   // Testimonial Slider
   jQuery('.testimonial-slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    dots: false,
    speed: 600,
    fade: true,
    cssEase: 'linear',
    nextArrow: '<svg class="arrow-next" xmlns="http://www.w3.org/2000/svg" width="22.203" height="39.796" viewBox="0 0 22.203 39.796"> <path id="np_down_1137388_000000" d="M30.1,40.3l1.5-1.4L50,58.2,68.4,38.9l1.5,1.4L50,61.1Z" transform="translate(-38.899 69.898) rotate(-90)" fill="#545454"/> </svg>',
    prevArrow: '<svg class="arrow-prev" xmlns="http://www.w3.org/2000/svg" width="22.203" height="39.796" viewBox="0 0 22.203 39.796"> <path id="np_down_1137388_000000" d="M0,20.8l1.5,1.4L19.9,2.9,38.3,22.2l1.5-1.4L19.9,0Z" transform="translate(0 39.796) rotate(-90)" fill="#545454"/> </svg>'
  });









  // slider
  
  jQuery('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.slider-nav'
  });
  jQuery('.slider-nav').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    // vertical:true,
    asNavFor: '.slider-for',
    dots: false,
    focusOnSelect: true,
    cssEase: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
    // verticalSwiping:true,
    // responsive: [
    // {
    //     breakpoint: 992,
    //     settings: {
    //       vertical: false,
    //     }
    // },
    // {
    //   breakpoint: 768,
    //   settings: {
    //     vertical: false,
    //   }
    // },
    // {
    //   breakpoint: 580,
    //   settings: {
    //     vertical: false,
    //     slidesToShow: 3,
    //   }
    // },
    // {
    //   breakpoint: 380,
    //   settings: {
    //     vertical: false,
    //     slidesToShow: 2,
    //   }
    // }
    // ]
  });

  jQuery('.cards-wrapper').slick({

  });
  jQuery('#slider-arrows-wrapper .arrow-right').on('click', function(){
    jQuery('.cards-wrapper .slick-next').trigger('click');
  });
  jQuery('#slider-arrows-wrapper .arrow-left').on('click', function(){
    jQuery('.cards-wrapper .slick-prev').trigger('click');
  });

  jQuery('.cards-wrapper').on('swipe', function(event, slick, direction){
    // console.log(direction);
    if(direction=='right') {
      jQuery('.cards-wrapper .slick-prev').trigger('click');
    }
    if(direction=='left') {
      jQuery('.cards-wrapper .slick-next').trigger('click');
    }
  });

  let sliderArrows = document.querySelectorAll('.slider-arrow');
sliderArrows.forEach(function (sliderArrow) {
    sliderArrow.addEventListener('click', function (e) {
        e.preventDefault()
    })
});

// toggle
jQuery('ol.toggle li h3').on('click', function() {
  jQuery('ol.toggle li h3').parent('li').removeClass('active');
  jQuery('ol.toggle li h3').next('.description').removeClass('show');
  jQuery('ol.toggle li h3').next('.description').slideUp('slow');

  if( jQuery(this).next('.description').hasClass('show') ) {
    // jQuery(this).parent('li').removeClass('active');
    jQuery(this).next('.description').removeClass('show');

  } else {
    jQuery(this).parent('li').addClass('active');
    jQuery(this).next('.description').addClass('show');
    jQuery(this).next('.description').slideDown('slow');
  }
});


// animate number counter

var counterUp = window.counterUp["default"]; // import counterUp from "counterup2"

var $counters = jQuery(".number-items .item .number span.count");
/* Start counting, do this on DOM ready or with Waypoints. */

$counters.each(function (ignore, counter) {
  var waypoint = new Waypoint({
    element: jQuery(this),
    handler: function handler() {
      counterUp(counter, {
        duration: 5000,
        delay: 16
      });
      this.destroy();
    },
    offset: 'bottom-in-view'
  });
});

  AOS.init();

  //Load News
  let offset = 0;
  let page_length = 20;
  if(windowWidth < 768) {
    page_length = 3;
  }
  function loadMoreNews() {
    const url = '/wp-json/wp/v1/load_news';
    let data = {
      // "articles": articles,
      "offset": offset,
      "page_length": page_length,
    };
    // if(jQuery('#tax-term').length){
    //     data.tax = jQuery('#tax-term').text();
    // }
    jQuery.ajax({
      url: url,
      dataType: 'json',
      type: 'get',
      contentType: 'application/json',
      data: data,
      success: function( result ){
        let html = '';
        let i = 0;
          
        result.news.forEach(function(news){
          i++;

          // <li class="blog-post d-flex" data-aos="fade-up" data-aos-offset="200" data-aos-delay="50" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-mirror="false" data-aos-once="true">
          //   <div class="media">
          //     <a href="${news.permalink}"><img class="image" src="${news.image}" alt="${news.title}"></a>
          //   </div>

          //   <div class="content">
          //     <a href="${news.permalink}">
          //       <h3>${news.title}</h3>
          //       <div class="description">
          //       <p>${news.excerpt}</p>
          //       </div>
          //     <a>
          //     <div class="meta">
          //       <div class="publish-date">${news.published_date}</div>
          //       <div class="category"><a href="${news.category_url}">${news.category_name}</a></div>
          //     </div>
          //   </div>
          html += `


              <li class="blog-post ${news.category_slug} d-flex">
              <div class="blog-blurb">
                <a href="${news.permalink}">
                  <h3 class="blog-title">${news.title}</h3>
                </a>
                <div class="category">
                  ${news.category_name}
                </div>
                <div class="button">
                  <a href="${news.permalink}">Read More
                  <svg id="Group_137" data-name="Group 137" xmlns="http://www.w3.org/2000/svg" width="111" height="111" viewBox="0 0 111 111"><g id="Ellipse_29" data-name="Ellipse 29" fill="none" stroke="#fff" stroke-width="3"><circle cx="55.5" cy="55.5" r="55.5" stroke="none"></circle><circle cx="55.5" cy="55.5" r="54"></circle></g><path id="np_arrow_1933596_000000" d="M32.729 4.875v57.309H30.1V4.875L2.691 32.408.848 30.565 31.413 0l30.564 30.565-1.712 1.844z" transform="rotate(45 13.924 72.539)" fill="#fff" fill-rule="evenodd"></path></svg>
                  </a>
                </div>
              </div>

              <div class="media">
                <a href="${news.permalink}">
                  <img class="image" src="${news.image}" alt="${news.title}">
                </a>
              </div>
            </li>
            </li>
          `;
        });
        if(offset == 0) {
          jQuery('.news-listing-wrapper').html(html);
        } else {
          jQuery('.news-listing-wrapper').append(html);
        }
        if(result.offset > 0) {
          jQuery('.btn-load-more').show();
        } else {
          jQuery('.btn-load-more').hide();
        }
        offset = result.offset;
      }
    });
  }

  if ( jQuery( ".news-listing-wrapper" ).length ) {
    loadMoreNews();
  }

  jQuery('#load-news').on('click', function(e) {
    e.preventDefault();
    loadMoreNews();
  });


  // get the X Y coordinate of caption element
  // if(document.getElementById('expand-wrap') !== null) {
  //   var parentPos = document.getElementById('expand-wrap').getBoundingClientRect(),
  //     childPos = document.getElementById('expand').getBoundingClientRect(),
  //     relativePos = {};

  //   // relativePos.top = childPos.top - parentPos.top,
  //   // relativePos.right = childPos.right - parentPos.right,
  //   // relativePos.bottom = childPos.bottom - parentPos.bottom,
  //   relativePos.left = childPos.left - parentPos.left;
    
  //   jQuery('.layout-contact-with-locations>.wrapper .wrap .left .left-wrap').css({ 'margin-left': - relativePos.left });
  // }

  // if(document.getElementById('expand-case-studies') !== null) {
  //   var parentPos1 = document.getElementById('expand-case-studies').getBoundingClientRect();
  //   if(document.getElementById('expand-left') !== null) {
  //     var childPos1 = document.getElementById('expand-left').getBoundingClientRect();
  //   }
  //   if(document.getElementById('expand-right') !== null) {
  //     var childPos1 = document.getElementById('expand-right').getBoundingClientRect();
  //   }
  //   var relativePos1 = {};

  //   relativePos1.right = childPos1.right - parentPos1.right,
  //   relativePos1.left = childPos1.left - parentPos1.left;
  //   if(document.getElementById('expand-left') !== null) {
  //     jQuery('.layout-case-studies .case-studies-wrapper #expand-left.case-study-wrapper .case-studies-list').css({ 'margin-left': - relativePos1.left });
  //   }
  //   if(document.getElementById('expand-right') !== null) {
  //     jQuery('.layout-case-studies .case-studies-wrapper #expand-right.case-study-wrapper .case-studies-list').css({ 'margin-right': relativePos1.right });
  //   }
  // }

  // if(document.getElementById('expand-team-wrap') !== null) {
  //   var parentPos2 = document.getElementById('expand-team-wrap').getBoundingClientRect(),
  //     childPos2 = document.getElementById('expand-team').getBoundingClientRect(),
  //     relativePos2 = {};

  //   // relativePos2.right = childPos2.right - parentPos2.right,
  //   relativePos2.left = childPos2.left - parentPos2.left;
    
  //   jQuery('.layout-team .team-wrapper .team-member-wrapper').css({ 'margin-right': - relativePos2.left });
  // }

  // expand associate
  // if(document.getElementById('stretch-image-left') !== null) {
  //   var parentPos3 = document.getElementById('stretch-image-left').getBoundingClientRect(),
  //     childPos3 = document.getElementById('stretch-i-left').getBoundingClientRect(),
  //     relativePos3 = {};

  //   // relativePos3.right = childPos3.right - parentPos3.right,
  //   relativePos3.left = childPos3.left - parentPos3.left;
    
  //   jQuery('#stretch-i-left .media').css({ 'margin-left': - relativePos3.left });
  // }

// get the X Y coordinate of caption element on scroll
// jQuery( window ).resize(function() {
//   if(document.getElementById('expand-wrap') !== null) {
//     var parentPos = document.getElementById('expand-wrap').getBoundingClientRect(),
//       childPos = document.getElementById('expand').getBoundingClientRect(),
//       relativePos = {};

//     // relativePos.top = childPos.top - parentPos.top,
//     // relativePos.right = childPos.right - parentPos.right,
//     // relativePos.bottom = childPos.bottom - parentPos.bottom,
//     relativePos.left = childPos.left - parentPos.left;
    
//     jQuery('.layout-contact-with-locations>.wrapper .wrap .left .left-wrap').css({ 'margin-left': - (relativePos.left) });
//   }

  // if(document.getElementById('expand-case-studies') !== null) {
  //   var parentPos1 = document.getElementById('expand-case-studies').getBoundingClientRect();
  //   if(document.getElementById('expand-left') !== null) {
  //     var childPos1 = document.getElementById('expand-left').getBoundingClientRect();
  //   }
  //   if(document.getElementById('expand-right') !== null) {
  //     var childPos1 = document.getElementById('expand-right').getBoundingClientRect();
  //   }
  //   var relativePos1 = {};

  //   relativePos1.right = childPos1.right - parentPos1.right,
  //   relativePos1.left = childPos1.left - parentPos1.left;
  //   if(document.getElementById('expand-left') !== null) {
  //     jQuery('.layout-case-studies .case-studies-wrapper #expand-left.case-study-wrapper .case-studies-list').css({ 'margin-left': - relativePos1.left });
  //   }
  //   if(document.getElementById('expand-right') !== null) {
  //     jQuery('.layout-case-studies .case-studies-wrapper #expand-right.case-study-wrapper .case-studies-list').css({ 'margin-right': relativePos1.right });
  //   }
  // }

  // if(document.getElementById('expand-team-wrap') !== null) {
  //   var parentPos2 = document.getElementById('expand-team-wrap').getBoundingClientRect(),
  //     childPos2 = document.getElementById('expand-team').getBoundingClientRect(),
  //     relativePos2 = {};

  //   // relativePos2.right = childPos2.right - parentPos2.right,
  //   relativePos2.left = childPos2.left - parentPos2.left;
    
  //   jQuery('.layout-team .team-wrapper .team-member-wrapper').css({ 'margin-right': - relativePos2.left });
  // }

  // expand associate
  
//   if(document.getElementById('stretch-image-left') !== null) {
//     var parentPos3 = document.getElementById('stretch-image-left').getBoundingClientRect(),
//       childPos3 = document.getElementById('stretch-i-left').getBoundingClientRect(),
//       relativePos3 = {};

//     // relativePos3.right = childPos3.right - parentPos3.right,
//     relativePos3.left = childPos3.left - parentPos3.left;
    
//     jQuery('#stretch-i-left .media').css({ 'margin-left': - relativePos3.left });
//   }
// });

// hamburger menu

jQuery('.extended-menu a').on('click', function(e){
  jQuery("#hamburger-menu").toggleClass("active");
  if(windowWidth > 1280) {
    e.preventDefault();
  }
});

jQuery('#hamburger-menu .wrap .secondary-menu>li.menu-item').on('click mouseover', function() {
  if(windowWidth > 1280) {
    jQuery("#hamburger-menu .wrap .secondary-menu>li").removeClass("active");
  }
  jQuery(this).addClass("active");
});

jQuery('#hamburger-menu .wrap .secondary-menu>li ul.sub-menu').on('click mouseover', function(e) {
  e.stopPropagation();
});

jQuery('#hamburger-menu .wrap .secondary-menu>li>ul.sub-menu>li.menu-item').on('click mouseover', function() {
  if(windowWidth > 1280) {
    jQuery("#hamburger-menu .wrap .secondary-menu>li.active>ul.sub-menu>li").removeClass("active");
  }
  jQuery(this).addClass("active");
});

jQuery('#hamburger-menu .wrap .secondary-menu>li ul.sub-menu li ul.sub-menu').on('click mouseover', function(e) {
  e.stopPropagation();
});

jQuery('#hamburger-menu .wrap .secondary-menu>li ul.sub-menu ul.sub-menu li.menu-item').on('click mouseover', function() {
  if(windowWidth > 1280) {
    jQuery("#hamburger-menu .wrap .secondary-menu>li.active>ul.sub-menu>li>ul.sub-menu>li").removeClass("active");
  }
  jQuery(this).addClass("active");
});

jQuery('.map')
	.click(function(){
			jQuery(this).find('iframe').addClass('clicked')})
	.mouseleave(function(){
			jQuery(this).find('iframe').removeClass('clicked')});

});

jQuery('.catetory-item a.filter-label').on('click', function(e) {
  e.preventDefault();
});

// filter gallery item on click
jQuery('.catetory-item').on('click', function() {
  var $filterClass = jQuery(this).children('a').attr('id');
  jQuery(".catetory-item .filter-label").removeClass('active');
  if( jQuery(this).children('a').hasClass($filterClass) ) {
    jQuery(this).children('a').addClass('active');
  }
  jQuery(this).closest('.filter').next('.blog-posts').children('.news-listing-wrapper').addClass('active');
  jQuery(this).closest('.filter').next('.blog-posts').children('.news-listing-wrapper').children('.blog-post').removeClass('active');
  jQuery(this).closest('.filter').next('.blog-posts').children('.news-listing-wrapper').children('.blog-post').filter("."+$filterClass).addClass('active');

  if( jQuery(this).children('a').hasClass('everything') ) {
    jQuery(this).closest('.filter').next('.blog-posts').children('.news-listing-wrapper').removeClass('active');
  }
});